export enum FeedbackCall {
  RFID_EDIT = 'kw.rfid-card-management',
  RFID_AUTHORIZATION = 'kw.rfid-authorization-management',
}
